import { ComponentProps } from 'react';
import SvgIcon from '@mui/material/SvgIcon';

type MuiIconProps = ComponentProps<typeof SvgIcon>;

export const FlipIcon = (props: MuiIconProps) => {
  return (
    <SvgIcon {...props}>
      <path d="M8 13C8.55228 13 9 13.4477 9 14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14C7 13.4477 7.44772 13 8 13Z" />
      <path d="M8 10C8.55228 10 9 10.4477 9 11C9 11.5523 8.55228 12 8 12C7.44772 12 7 11.5523 7 11C7 10.4477 7.44772 10 8 10Z" />
      <path d="M0.882812 4.29297C1.27333 3.90245 1.90635 3.90247 2.29688 4.29297L6.00391 8L2.29688 11.707L2.2207 11.7754C1.82806 12.0953 1.24881 12.0727 0.882812 11.707C0.693603 11.5178 0.597506 11.2714 0.591797 11.0234H0.589844V5C0.589838 4.74415 0.687771 4.48825 0.882812 4.29297Z" />
      <path d="M13.707 4.29297C14.0976 3.90244 14.7306 3.90244 15.1211 4.29297C15.3162 4.48826 15.4141 4.74412 15.4141 5V11.0234H15.4121C15.4064 11.2714 15.3103 11.5178 15.1211 11.707C14.7551 12.0727 14.1758 12.0953 13.7832 11.7754L13.707 11.707L10 8L13.707 4.29297Z" />
      <path d="M8 7C8.55228 7 9 7.44772 9 8C9 8.55228 8.55228 9 8 9C7.44772 9 7 8.55228 7 8C7 7.44772 7.44772 7 8 7Z" />
      <path d="M8 4C8.55228 4 9 4.44772 9 5C9 5.55228 8.55228 6 8 6C7.44772 6 7 5.55228 7 5C7 4.44772 7.44772 4 8 4Z" />
      <path d="M8 1C8.55228 1 9 1.44772 9 2C9 2.55228 8.55228 3 8 3C7.44772 3 7 2.55228 7 2C7 1.44772 7.44772 1 8 1Z" />
    </SvgIcon>
  );
};
